var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M7.14886 0.770706C8.55081 -0.24787 10.4492 -0.247872 11.8511 0.770704L17.1349 4.60962C18.5369 5.62819 19.1235 7.43366 18.588 9.08175L16.5698 15.2932C16.0343 16.9413 14.4985 18.0572 12.7656 18.0572H6.23442C4.50152 18.0572 2.9657 16.9413 2.4302 15.2932L0.411963 9.08176C-0.123534 7.43367 0.463098 5.62819 1.86505 4.60962L7.14886 0.770706Z",
    fill: "#F5F5F5",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.193cbb7b364ea8bfcbdbcc2674effd4d.svg";
export { ForwardRef as ReactComponent };